module.exports = "<div id=\"sidebar\" class=\"layout--sidebar\">\n    <div id=\"sidebar--navbar\" class=\"layout--navbar\"></div>\n    <div id=\"sidebar--content\" class=\"layout--body -scroll\"></div>\n</div>\n\n<div id=\"content\" class=\"layout--content hidden-xs\"></div>\n\n<div id=\"layout--backdrop\" class=\"layout--backdrop\"></div>\n\n<div id=\"layout--brand\" class=\"layout--brand -loading\">\n    <div id=\"loading--circle\" class=\"loading--circle -loading\">\n        <div></div>\n    </div>\n</div>\n\n<div id=\"layout--modal\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/templates/layout.html
// module id = 668
// module chunks = 0